import { useCallback, useEffect, useState } from "react";

export function useApi(loader, dependencies = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setData(await loader());
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  }, dependencies);

  // Mutations refresh data without unmounting the current view. Let the
  // caller display refresh failures beside the action that caused them.
  const refresh = useCallback(async () => {
    const nextData = await loader();
    setData(nextData);
    return nextData;
  }, dependencies);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, error, loading, reload, refresh, setData };
}
